type Props = { fill?: string; size?: number };

const UncheckedIcon = ({ fill, size = 20 }: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="0.5"
        width="19"
        height="19"
        rx="5.5"
        stroke={fill ?? "#1064DB"}
      />
    </svg>
  );
};

export default UncheckedIcon;
